<template>
    <el-dialog :title="dialog.title" width="60%" :visible.sync="dialog.visible" class="approvalType-dialog">
        <div class="action-btn">
            <el-button type="primary" size="mini" @click="showType('add')">添加</el-button>
        </div>
        <el-table :data="tableData" v-loading="loading" class="type-table">
            <el-table-column property="id" label="ID" width="150"></el-table-column>
            <el-table-column property="title" label="类型名称" width="200"></el-table-column>
            <el-table-column property="name" label="类型别名"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="{ row }">
                    <el-button type="primary" size="mini" @click="showType('edit', row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="removeType(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog width="30%" :title="typeDialog.title" :visible.sync="typeDialog.visible" :before-close="closeDialog" append-to-body>
            <el-form
                :model="approvalTypeForm"
                ref="approvalTypeForm"
                label-position="left"
                label-width="80px"
                :rules="approvalTypeFormRules"
            >
                <el-form-item label="类型名称" prop="title">
                    <el-input v-model="approvalTypeForm.title"></el-input>
                </el-form-item>
                <el-form-item label="类型别名" prop="name">
                    <el-input v-model="approvalTypeForm.name"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="approvalTypeForm.sort"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
export default {
    name: 'saveApproval',
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            loading: false,
            dialog: {
                title: '',
                visible: false,
                type: ''
            },
            typeDialog: {
                title: '',
                visible: false,
                type: ''
            },
            // 添加类型表单
            approvalTypeForm: {
                id: '',
                title: '',
                sort: 0,
                name: ''
            },
            approvalTypeFormRules: {
                title: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
                name: [{ required: true, message: '请输入类型别名', trigger: 'blur' }]
            }
        };
    },
    methods: {
        // 显示
        showDialog() {
            this.dialog.visible = true;
            this.dialog.title = '审批类型列表';
        },

        // 显示添加/编辑类型弹窗
        showType(type, row) {
            let that = this;
            that.typeDialog.visible = true;
            if (type == 'add') {
                that.typeDialog.type = 'add';
                that.typeDialog.title = '添加审批类型';
            } else {
                that.typeDialog.type = 'edit';
                that.typeDialog.title = '编辑审批规则';
                let url = '/api/audit.category/read';
                let params = {
                    id: row.id
                };
                that.$post(url, params).then(function (res) {
                    if (res.code == 200) {
                        that.approvalTypeForm = res.data.row;
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            }
        },

        // 删除类型
        removeType(row) {
            let that = this;
            let url = '/api/audit.category/delete';
            let params = {
                id: row.id
            };
            that.$confirm('此操作不可撤销，请确认！', '提示', () => {})
                .then(() => {
                    that.$post(url, params).then(function (res) {
                        if (res.code == 200) {
                            that.$message.success(res.msg);
                            that.$emit('getTypeList');
                        } else {
                            that.$message.error(res.msg);
                        }
                    });
                })
                .catch(() => {});
        },

        // 关闭
        closeDialog() {
            this.$refs['approvalTypeForm'].resetFields();
            this.approvalTypeForm = {
                id: '',
                title: '',
                sort: 0,
                name: ''
            };
            this.typeDialog = {
                title: '',
                visible: false,
                type: ''
            };
        },

        // 提交
        submit() {
            let that = this;
            let params = that.approvalTypeForm;
            that.$refs['approvalTypeForm'].validate((valid) => {
                if (valid) {
                    if (that.typeDialog.type == 'add') {
                        let url = '/api/audit.category/create';
                        this.$post(url, params).then(function (res) {
                            if (res.code == 200) {
                                that.closeDialog();
                                that.$message.success(res.msg);
                                that.$emit('getTypeList');
                            } else {
                                that.$message.error(res.msg);
                            }
                        });
                    } else {
                        let url = '/api/audit.category/save';
                        this.$post(url, params).then(function (res) {
                            if (res.code == 200) {
                                that.closeDialog();
                                that.$message.success(res.msg);
                                that.$emit('getTypeList');
                            } else {
                                that.$message.error(res.msg);
                            }
                        });
                    }
                } else {
                    that.$message.warning('请检查您的填写');
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.approvalType-dialog {
    .action-btn {
        margin: 10px 0;
        text-align: end;
    }

    .type-table {
        max-height: 48vh;
        overflow: auto;
    }

    .el-table::before {
        background: none;
    }
}
</style>